var map = {
	"./frame_degree_m_1.png": "96a1",
	"./frame_degree_m_2.png": "aa49",
	"./frame_degree_m_3.png": "d6bb",
	"./frame_degree_m_4.png": "12c8",
	"./frame_degree_s_1.png": "f98f",
	"./frame_degree_s_2.png": "ef2b",
	"./frame_degree_s_3.png": "bc7e",
	"./frame_degree_s_4.png": "01de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "da7b";